import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
  FormControl
} from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Params } from '@angular/router';

import { environment } from '../../../../environments/environment';
import { CrudService } from '../../../crud/crud.service';
import { NotificationsService } from 'angular2-notifications';
import { CurrencyPipe } from '@angular/common';

import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable'; import * as jQuery from 'jquery';
import * as moment from 'moment';

import { materialize } from 'rxjs/operators';

import { HttpClient, HttpHeaders, HttpResponse  } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map} from 'rxjs/operators';

@Component({
  selector: 'app-reporte-alumno',
  templateUrl: './reporte-alumno.component.html',
  styles: ['ngui-auto-complete {z-index: 999999 !important}']
})
export class ReporteAlumnoComponent implements OnInit{
  tab = 1;
  dato = [];
  docentes = [];
  carrera_modulo_nivel;
  periodos_escolares_niveles;
  grupos_niveles;
  carrera_plan;
  cargando = false;

  borrarCargando = false;

  // Mensaje
  titulo; mensaje; clase;


  time_cal;

  empresa = localStorage.getItem("empresa");
  sucursal = localStorage.getItem("sucursal");
  public alumnos_term: string = `${
    environment.API_URL
  }/alumnos-auto?term=:keyword&empresa=${this.empresa}&sucursal=${
    this.sucursal
  }`;

  tieneid: boolean = false;

  auto = 0;

  configuracion = JSON.parse(localStorage.getItem("configuracion"));
  usuario = JSON.parse(localStorage.getItem("usuario"));
  permisos = JSON.parse(localStorage.getItem("permisos"));

  json;
  alumnos = {
    id: "",
    matricula: "",
    alumnos_metadatos: {
      nombre: "",
      apellido_paterno: "",
      apellido_materno: "",
      matricula: ""
    },
    grupos: {
      nombre: "",
      clave: "",
      identificador: "",
      nivel: "",
      turnos: {
        nombre: ""
      }
    },
    becas: {
      importe: 0
    },
    carrera_plan: {
      id: "",
      nombre: ""
    },
    carreras: {
      sigla: '',
      nombre: ''
    }
  };

  periodos_escolares;
  documentos = [];
  kardex = [];
  finanza = {
    data: [],
    otros_pagos: [],
    cupones: []
  };
  lista_incidencias = [];
  carreras_planes;
  constructor(
    private crudService: CrudService,
    private route: ActivatedRoute,
    private _sanitizer: DomSanitizer,
    private http: HttpClient,
    private notificacion: NotificationsService
  ) {}

  observableSource = (keyword: any): Observable<any[]> => {
    
    let url: string =  `${environment.API_URL}/alumnos-auto?term=${keyword}&empresa=${this.empresa}&sucursal=${this.sucursal}`
    if (keyword) {
      return this.http.get(url).pipe(map((response: HttpResponse<any>) => {
        let data: any = response;
        return data.data;
      }));
        
    } else {
      return Observable.bind([]);
    }
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params["id"]) {
        this.tieneid = true;
      }
    });
    this.dato[0] = 0;
  }
  /**
   * Este método formatea los resultados de la busqueda en el autocomplte
   * @param data resultados de la busqueda
   * @return void
   */
  autocompleListFormatter = (data: any) => {
    if (this.auto == 0) {
      $("ngui-auto-complete").attr(
        "style",
        $("ngui-auto-complete").attr("style") + "z-index:999"
      );
    }
    let html = `
    <div class="card" >
      <div class="card-content">
        <div class="media">
          <div class="media-content">
            <h4 style="font-size:1.5em; color:#292929; font-weight: 600;">
            ${data.alumnos_metadatos.nombre} ${
      data.alumnos_metadatos.apellido_paterno
    } ${data.alumnos_metadatos.apellido_materno}
            <small style="font-size: .5em; font-style: italic;">
           ${data.alumnos_metadatos.email}
            </small></h4>
            <h6>
              <strong>CURP: </strong> ${
                data.alumnos_metadatos.curp
              } <strong>Tutor: </strong> ${data.alumnos_metadatos.tutor_nombre}
              `;
    html += `<label class="tag is-success" >Domicilio: ${
      data.alumnos_metadatos.calle
    }, ${data.alumnos_metadatos.no_exterior}, ${
      data.alumnos_metadatos.colonia
    } </label>`;

    html += `<label class="tag is-warning" >CP : ${
      data.alumnos_metadatos.codigo_postal
    }</label>`;

    html += `
            </h6>
          </div>
        </div>
      </div>
    </div>`;
    this.auto++;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  };

  /**
   * Este método agrega los lostes del modal a el modelo que se envia a la api
   * @return void
   */
  select_articulo_autocomplete(data) {
    this.cargando = true;
    this.auto = 0;

    if (!data.alumnos_metadatos.hasOwnProperty("foto")) {
      data.alumnos_metadatos.foto = "";
    }
    if (!data.alumnos_metadatos.hasOwnProperty("avatar")) {
      data.alumnos_metadatos.avatar = "";
    }
    this.alumnos = data;
    document.getElementById("catalogos").click();
    this.cargarDatos(this.alumnos.id);
    (<HTMLInputElement>document.getElementById("buscarArticulo")).value = "";
  }
  cargarDatos(id) {
    this.dato = [];
    this.carrera_modulo_nivel = [];
    this.carrera_plan = [];
    this.cargando = true;
    this.crudService.ver(this.alumnos.id, "alumno-operacion/reporte").subscribe(
      resultado => {
        if (resultado.status == 200) {
          this.kardex = resultado.kardex;
          this.finanza = resultado.finanza;
          this.lista_incidencias = resultado.personas_incidencias;

          this.carreras_planes = resultado.carreras_planes;
          this.periodos_escolares = resultado.periodos_escolares;
          this.carrera_modulo_nivel = resultado.carrera_modulo_nivel;

        } else {
          this.titulo = "No configurado";
          this.mensaje = "No se encontro datos";
          this.clase = "warning";
          document.getElementById("message").click();
        }
        this.cargando = false;
      },
      error => {
        this.cargando = false;
        this.titulo = "Error";
        this.mensaje = "Algo salio mal";
        this.clase = "danger";
        document.getElementById("message").click();
      }
    );
  }


  logo_sucursal = "";
  logo_empresa = "";
  logo_carrera = "";

  imprimirKardex() {
    this.cargando = true;
    moment.locale("es");
    let fecha = moment(new Date()).format("dddd [,] D [de] MMMM [del] YYYY");
    setTimeout(() => {
      let doc = new jsPDF("portrait", "mm", "letter");


      doc.setFont("helvetica");

      doc.setLineWidth(0.1);
      doc.setDrawColor(1, 1, 1);
      doc.setFillColor(255, 255, 255);

      let contador = 0;

      let alumno = this.kardex[this.alumnos.id];
        let conteo_lienas = 4;

        let logo = this.logo_sucursal != "" ? this.logo_sucursal : this.logo_empresa;
        if (logo != "")
          doc.addImage(logo, "PNG", 10, 5, 16, 16, "", "FAST");
        //Nombre empresa
        doc.setFontSize(10);
        doc.setFont("helvetica", "", "bold");
        doc.setFont("helvetica");
        doc.text(this.configuracion.empresa.nombre,110, 12,  {align:"center"});
        doc.text(this.configuracion.empresa.subnombre,110, 17,  {align:"center"});

        doc.setFontSize(8);
        doc.setFont("helvetica", "", "normal");
        doc.text("Campus: " + this.configuracion.sucursal.nombre,110, 20,  {align:"center"});

        conteo_lienas += 20;
        doc.setFontSize(8);
        doc.setFont("helvetica", "", "bold");

        doc.text("HISTORIAL ACADEMICO",110, conteo_lienas,  {align:"center"});
        conteo_lienas += 4;

        doc.setFontSize(6);
        doc.text("CARRERA: ",10, conteo_lienas,  {align:"left"});
        doc.text("CLAVE: ", 145, conteo_lienas, {align:"left"});

        doc.line(25, conteo_lienas + 1, 135, conteo_lienas + 1);
        doc.line(155, conteo_lienas + 1, 206, conteo_lienas + 1);

        doc.text("NOMBRE: ",10, conteo_lienas + 4,  {align:"left"});
        doc.text("TURNO: ",145, conteo_lienas + 4,  {align:"left"});

        doc.line(25, conteo_lienas + 5, 135, conteo_lienas + 5);
        doc.line(155, conteo_lienas + 5, 206, conteo_lienas + 5);

        doc.text("MATRICULA: ",10, conteo_lienas + 8,  {align:"left"});
        doc.text("GRUPO: ",145, conteo_lienas + 8,  {align:"left"});

        doc.line(25, conteo_lienas + 9, 135, conteo_lienas + 9);
        doc.line(155, conteo_lienas + 9, 206, conteo_lienas + 9);

        ///////////////////////////////////////
        doc.setFont("helvetica", "", "normal");

      doc.text(this.alumnos.carreras.nombre + " - " + this.alumnos.carrera_plan.nombre,30, conteo_lienas,  {align:"left"});
      doc.text( this.alumnos.carreras.sigla,160, conteo_lienas, {align:"left"});

        doc.text(alumno.nombre,30, conteo_lienas + 4,  {align:"left"});
        doc.text(alumno.calificacion.turno,160, conteo_lienas + 4,  {align:"left"});

        doc.text(alumno.matricula ? alumno.matricula : '',30, conteo_lienas + 8,  {align:"left"});
        doc.text(alumno.calificacion.clave + " " + alumno.calificacion.nivel + " " + alumno.calificacion.identificador,160, conteo_lienas + 8,  {align:"left"});

        conteo_lienas += 12;
        let conteo_lin = [];
        conteo_lin[0] = conteo_lienas;
        conteo_lin[1] = conteo_lienas;
        let columns1 = [];
        let rows1 = [];
        let columns2 = [];
        let rows2 = [];
        let columns3 = [];
        let rows3 = [];
        let materias = this.carreras_planes[this.alumnos.carrera_plan.id].materias;

        for (let key in materias) {
          let c = parseInt(key);
          if (c > 0) {
            let periodo = "";
            if (typeof this.periodos_escolares[this.alumnos.carrera_plan.id] != 'undefined') {
              if (typeof this.periodos_escolares[this.alumnos.carrera_plan.id][key] != 'undefined') {
                periodo = this.periodos_escolares[this.alumnos.carrera_plan.id][key].nombre;
              }
            }
            columns1 = [
              {
                title: this.carreras_planes[this.alumnos.carrera_plan.id].carreras.tipos_periodos.nombre_para_mostrar + ": " + key,
                dataKey: "nivel"
              },
              {
                title: "PERIODO: " + periodo,
                dataKey: "periodo"
              }
            ];

            columns2 = [
              { title: "", dataKey: "mate" },
              { title: "CALIF.", dataKey: "calif" },
              { title: "REGULARIZACIÓN ", dataKey: "regula" }
            ];
            let modalidades_id = this.carrera_modulo_nivel[this.alumnos.carrera_plan.id][key].modalidades.id;
            columns3 = [
              { title: "MATERIA", dataKey: "materia" }
            ];
            let opcion = this.carreras_planes[this.alumnos.carrera_plan.id].opciones_calificacion;
            for (let ko in opcion) {
              if (modalidades_id == opcion[ko].modalidades_id) {
                columns3.push({ title: opcion[ko].nombre, dataKey: opcion[ko].nombre })
              }
            }
            let tamano_nombre_materia = 0;
            let materias_rows = [];
            for (let km in materias[key]) {
              if (materias[key][km].es_practica === 0 || materias[key][km].imprimible_boleta === 1) {
                let materia_d = {};

                let materia_nombre = materias[key][km].nombre;
                if (materias[key][km].tiene_practica) {
                  materia_nombre = materia_nombre + " *";
                }

                if (materia_nombre.length > 48) {
                  tamano_nombre_materia++;
                }

                materia_d["materia"] = materia_nombre;
                for (let ko in opcion) {

                  if (modalidades_id == opcion[ko].modalidades_id) {

                    let promedio = {
                      aprobado: '',
                      carreras_planes_id: '',
                      clave: '',
                      id: '',
                      identificador: '',
                      materia_clave: '',
                      materia_id: '',
                      materia_nombre: '',
                      nivel: '',
                      opciones_calificacion_id: '',
                      periodos_escolares_id: '',
                      personas_id: '',
                      promedio: '',
                      turno: '',
                      valor_minimo_aprobatorio: '',
                    };
                    let no_opcion = false;

                    if (alumno.niveles[key]) {
                      if (alumno.niveles[key][materias[key][km].id]) {
                        if (alumno.niveles[key][materias[key][km].id][opcion[ko].id]) {
                          promedio.promedio = alumno.niveles[key][materias[key][km].id][opcion[ko].id].promedio;
                        } else {
                          no_opcion = true;
                        }
                      } else {
                        no_opcion = true;
                      }
                    } else {
                      no_opcion = true;
                    }
                    if (no_opcion) {
                      promedio.promedio = '';
                    }
                    if (parseFloat(promedio.promedio) < parseFloat(promedio.valor_minimo_aprobatorio)) {
                      promedio.promedio = this.carrera_modulo_nivel[this.alumnos.carrera_plan.id][key].modalidades.materia_leyenda_para_imprimir;
                    }

                    materia_d[opcion[ko].nombre] = promedio.promedio;
                  }
                }

                materias_rows.push(materia_d);
              }
            }
            rows3 = materias_rows;

            if (c % 2 == 0) {
              if (conteo_lin[1] + (rows3.length + tamano_nombre_materia) * 4.9 > 356) {
                conteo_lin[0] = 10;
                conteo_lin[1] = 10;
                conteo_lienas = 10;
                doc.addPage();
              }
              (doc as any).autoTable(columns1, rows1, {
                createdHeaderCell: function (cell, data) {
                  cell.styles.halign = "left";
                },
                tableWidth: 96,
                margin: { left: 110, right: 10 },
                startY: conteo_lin[1],
                styles: {
                  fontSize: 7,
                  font: "helvetica",
                  halign: "left",
                  fillColor: "#FFFFFF",
                  textColor: "#000000",
                  lineColor: "#000000",
                  lineWidth: 0.1,
                  overflow: 'linebreak',
                  cellPadding: 0.3
                },
                headStyles: {
                  lineColor: "#000000",
                  lineWidth: 0.1,
                  fillColor: "#fbfbfb"
                },
                theme: "grid",
                columnStyles: {
                  nivel: { cellWidth: 30 },
                  periodo: { cellWidth: 66 }
                }
              });
              conteo_lin[1] += 3.5;
              const esto = this;
              let columnStyles = {
                materia: {
                  halign: "left",
                  cellWidth: 42
                }
              };

              for (let ko in opcion) {
                columnStyles[opcion[ko].nombre] = { cellWidth: (150 / (opcion.length)) };
              }

              (doc as any).autoTable(columns3, rows3, {
                didParseCell : function (cell) {
              let value = cell;
              cell = cell.cell;
                  cell.styles.fillColor = "#ffffff";
                  cell.styles.fontColor = "#000000";
                  if ((value.cell.text * 1) < esto.carrera_modulo_nivel[this.alumnos.carrera_plan.id][key].minimo_aprobatorio && value.column.dataKey != "materia") {
                    cell.styles.textColor = "#e11d1d";
                  };

                  if (value.column.dataKey != 'materia') {
                    cell.styles.halign = 'center';
                  };
                },
                tableWidth: 96,
                margin: { left: 110, right: 10 },
                startY: conteo_lin[1],
                styles: {
                  fontSize: 7,
                  font: "helvetica",
                  halign: "left",
                  fillColor: "#FFFFFF",
                  textColor: "#000000",
                  lineColor: "#000000",
                  lineWidth: 0.1,
                  overflow: 'linebreak',
                  cellPadding: 0.3
                },
                theme: "grid",
                columnStyles: {
                  materia: {
                    halign: "left",
                    cellWidth: 70
                  }
                },
                headStyles: {
                  cellPadding: 2,
                  lineWidth: 0.1,
                  valign: "top",
                  fontSize: 6,
                  fontStyle: "bold",
                  fillColor: "#fbfbfb",
                  textColor: "#000000",
                  lineColor: "#000000"
                }
              });
              conteo_lin[1] += (rows3.length + tamano_nombre_materia) * 4.9;
            } else {
              if (conteo_lin[0] + (rows3.length + tamano_nombre_materia) * 4.9 > 240) {
                conteo_lin[0] = 10;
                conteo_lin[1] = 10;
                conteo_lienas = 10;
                doc.addPage();
              }
              (doc as any).autoTable(columns1, rows1, {
                createdHeaderCell: function (cell, data) {
                  cell.styles.halign = "left";
                },
                tableWidth: 96,
                startY: conteo_lin[0],
                styles: {
                  fontSize: 7,
                  font: "helvetica",
                  halign: "left",
                  fillColor: "#FFFFFF",
                  textColor: "#000000",
                  lineColor: "#000000",
                  lineWidth: 0.1,
                  overflow: 'linebreak',
                  cellPadding: 0.3
                },
                theme: "grid",
                margin: { left: 10 },
                headStyles: {
                  lineColor: "#000000",
                  lineWidth: 0.1,
                  fillColor: "#fbfbfb"
                },
                columnStyles: {
                  nivel: { cellWidth: 30 },
                  periodo: { cellWidth: 66 }
                }
              });
              conteo_lin[0] += 3.5;
              const esto = this;
              (doc as any).autoTable(columns3, rows3, {
                didParseCell : function (cell) {
              let value = cell;
              cell = cell.cell;
                  cell.styles.fillColor = "#ffffff";
                  cell.styles.fontColor = "#000000";
                  if ((value.cell.text * 1) < esto.carrera_modulo_nivel[this.alumnos.carrera_plan.id][key].minimo_aprobatorio && value.column.dataKey != "materia") {
                    cell.styles.textColor = "#e11d1d";
                  };

                  if (value.column.dataKey != 'materia') {
                    cell.styles.halign = 'center';
                  };
                },
                tableWidth: 96,
                startY: conteo_lin[0],
                styles: {
                  fontSize: 7,
                  font: "helvetica",
                  halign: "left",
                  fillColor: "#FFFFFF",
                  textColor: "#000000",
                  lineColor: "#000000",
                  lineWidth: 0.1,
                  overflow: 'linebreak',
                  cellPadding: 0.3
                },
                theme: "grid",
                margin: { left: 10 },
                columnStyles: {
                  materia: {
                    halign: "left",
                    cellWidth: 70
                  }
                },
                headStyles: {
                  cellPadding: 2,
                  lineWidth: 0.1,
                  fontSize: 6,
                  valign: "top",
                  fontStyle: "bold",
                  fillColor: "#fbfbfb",
                  textColor: "#000000",
                  lineColor: "#000000"
                }
              });

              conteo_lin[0] += (rows3.length + tamano_nombre_materia) * 4.9;
            }
          }
        }
        conteo_lienas = conteo_lin[1] + 2;
        if (conteo_lin[0] > conteo_lin[1])
          conteo_lienas = conteo_lin[0] + 2;

        conteo_lienas += 2;
        doc.text("ACREDITADO " + alumno.total_creditos_aprobados + " DE UN TOTAL DE " + alumno.total_creditos + " CRÉDITOS. CON UN PROMEDIO DE: " + alumno.promedio,10, conteo_lienas, {align:"left"});

        doc.setFontSize(7);
        doc.text(fecha.toUpperCase(),200, 265,  {align:"right"});

      this.cargando = false;

      // doc.autoPrint();
      const string = (doc as any).output("datauristring", "kardex.pdf");

      $("#contenido").html(
        "<iframe border='0' style='border:0px' width='100%' height='100%' src='" +
        string +
        "'></iframe>");

    }, 10);
  }

  imprimirFinanza() {
    this.cargando = true;
    moment.locale("es");
    let fecha = moment(new Date()).format("dddd [,] D [de] MMMM [del] YYYY");
    setTimeout(() => {
      let doc = new jsPDF("portrait", "mm", "letter");


      doc.setFont("helvetica");

      doc.setLineWidth(0.1);
      doc.setDrawColor(1, 1, 1);
      doc.setFillColor(255, 255, 255);

      let conteo_lienas = 4;

      let logo = this.logo_sucursal != "" ? this.logo_sucursal : this.logo_empresa;
      if (logo != "")
        doc.addImage(logo, "PNG", 10, 5, 16, 16, "", "FAST");
      //Nombre empresa
      doc.setFontSize(10);
      doc.setFont("helvetica", "", "bold");
      doc.setFont("helvetica");
      doc.text(this.configuracion.empresa.nombre,110, 12,  {align:"center"});
      doc.text(this.configuracion.empresa.subnombre,110, 17,  {align:"center"});

      doc.setFontSize(8);
      doc.setFont("helvetica", "", "normal");
      doc.text( "Campus: " + this.configuracion.sucursal.nombre,110, 20, {align:"center"});

      conteo_lienas += 20;
      doc.setFontSize(8);
      doc.setFont("helvetica", "", "bold");

      doc.text("HISTORIAL FINANCIERO",110, conteo_lienas,  {align:"center"});
      conteo_lienas += 4;

      doc.setFontSize(6);
      doc.text( "CARRERA: ",10, conteo_lienas, {align:"left"});
      doc.text("CLAVE: ",145, conteo_lienas,  {align:"left"});

      doc.line(25, conteo_lienas + 1, 135, conteo_lienas + 1);
      doc.line(155, conteo_lienas + 1, 206, conteo_lienas + 1);

      doc.text("NOMBRE: ",10, conteo_lienas + 4,  {align:"left"});
      doc.text("TURNO: ",145, conteo_lienas + 4,  {align:"left"});

      doc.line(25, conteo_lienas + 5, 135, conteo_lienas + 5);
      doc.line(155, conteo_lienas + 5, 206, conteo_lienas + 5);

      doc.text("MATRICULA: ",10, conteo_lienas + 8,  {align:"left"});
      doc.text("GRUPO: ",145, conteo_lienas + 8,  {align:"left"});

      doc.line(25, conteo_lienas + 9, 135, conteo_lienas + 9);
      doc.line(155, conteo_lienas + 9, 206, conteo_lienas + 9);

      ///////////////////////////////////////
      doc.setFont("helvetica", "", "normal");

      doc.text(this.alumnos.carreras.nombre + " - " + this.alumnos.carrera_plan.nombre,30, conteo_lienas,  {align:"left"});
      doc.text(this.alumnos.carreras.sigla,160, conteo_lienas,  {align:"left"});

      doc.text(this.alumnos.alumnos_metadatos.nombre + " " + this.alumnos.alumnos_metadatos.apellido_paterno  + " " + this.alumnos.alumnos_metadatos.apellido_materno,30, conteo_lienas + 4,  {align:"left"});
      doc.text(this.alumnos.grupos.turnos.nombre,160, conteo_lienas + 4,  {align:"left"});

      doc.text(this.alumnos.matricula ? this.alumnos.matricula : '',30, conteo_lienas + 8,  {align:"left"});
      doc.text(this.alumnos.grupos.clave + " " + this.alumnos.grupos.nivel + " " + this.alumnos.grupos.identificador,160, conteo_lienas + 8,  {align:"left"});

      conteo_lienas += 15;

      doc.text("INSCRIPCION Y COLEGIATURA",110, conteo_lienas,  {align:"center"});
      conteo_lienas += 3;

      let columns1 = [], columns2 = [], columns3 = [];

      let rows1 = [], rows2 = [], rows3 = [];

      columns1 = [
        { title: 'N°', dataKey: 'id' },
        { title: 'DESCRIPCION', dataKey: 'descripcion' },
        { title: 'FECHA', dataKey: 'fecha' },
        { title: 'PAGO EL', dataKey: 'created_at' },
        { title: 'PRECIO', dataKey: 'precio' },
        { title: 'DESCUENTO', dataKey: 'descuento' },
        { title: 'RECARGO', dataKey: 'recargo' },
        { title: 'TOTAL', dataKey: 'total' },
      ];

      columns2 = [
        { title: 'N°', dataKey: 'id' },
        { title: 'DESCRIPCION', dataKey: 'descripcion' },
        { title: 'FECHA', dataKey: 'fecha' },
        { title: 'CANTIDAD', dataKey: 'cantidad' },
        { title: 'PRECIO', dataKey: 'precio' },
        { title: 'DESCUENTO', dataKey: 'descuento' },
        { title: 'TOTAL', dataKey: 'total' },
      ];

      columns3 = [
        { title: 'N°', dataKey: 'id' },
        { title: 'DESCRIPCION', dataKey: 'descripcion' },
        { title: 'VIGENCIA INICIO', dataKey: 'inicio' },
        { title: 'VIGENCIA FIN', dataKey: 'fin' },
        { title: 'TOTAL', dataKey: 'total' },
      ];
      this.finanza.data.forEach(inscripcion => {
        rows1[0] = [];
        rows1[0]["id"] = inscripcion.nivel;
        rows1[0]["descripcion"] = inscripcion.tipo;
        rows1[0]["fecha"] = inscripcion.fecha_pago;
        rows1[0]["created_at"] = inscripcion.created_at;
        rows1[0]["precio"] = this.convertirMoneda(parseFloat(inscripcion.precio_real));
        rows1[0]["descuento"] = this.convertirMoneda(parseFloat(inscripcion.descuento));
        rows1[0]["recargo"] = this.convertirMoneda(parseFloat(inscripcion.recargo_inscripcion));
        rows1[0]["total"] = inscripcion.total_abonado != 'DEBE' ? this.convertirMoneda(parseFloat(inscripcion.total_abonado)) : inscripcion.total_abonado;

        rows2 = [];

        (doc as any).autoTable(columns1, rows1, {
          startY: conteo_lienas,
          styles: {
            fontSize: 7, font: "helvetica",
            halign: "center",
            textColor: "#000000",
            lineColor: "#000000",
            lineWidth: 0.3
          },
          headStyles: {
            lineColor: "#000000",
            lineWidth: 0.3
          },
          bodyStyles: {
            cellPadding: 0.4
          },
          theme: "grid",
          tableWidth: 'auto',
          margin: { right: 10, left: 10 },
        });

        inscripcion.colegiaturas.forEach(colegiatura => {
          let raw = [];
          raw["id"] = colegiatura.numero_mensualidad;
          raw["descripcion"] = "COLEGIATURA";
          raw["fecha"] = colegiatura.fecha_pago;
          raw["created_at"] = colegiatura.created_at;
          raw["precio"] = this.convertirMoneda(parseFloat(colegiatura.precio_real));
          raw["descuento"] = this.convertirMoneda(parseFloat(colegiatura.descuento));
          raw["recargo"] = this.convertirMoneda(parseFloat(colegiatura.recargo_colegiatura));
          raw["total"] = this.convertirMoneda(parseFloat(colegiatura.total_abonado));

          rows2.push(raw);
        });
        conteo_lienas += 10;
        (doc as any).autoTable(columns1, rows2, {
          didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
            cell.styles.fillColor = "#ffffff";
          },
          startY: conteo_lienas,
          styles: {
            fontSize: 7, font: "helvetica",
            halign: "center",
            fillColor: "#FFFFFF",
            textColor: "#000000",
            lineColor: "#000000",
            lineWidth: 0.3,
            cellPadding: 0.4
          },
          headStyles: {
            lineColor: "#000000",
            fillColor: "#e2e2e2",
            lineWidth: 0.3
          },
          tableWidth: 'auto',
          margin: { right: 10, left: 10 },
        });

        conteo_lienas += inscripcion.colegiaturas.length * 5;
      });
      if (this.finanza.otros_pagos.length > 0) {
        conteo_lienas += 10;
        doc.text("OTROS PAGOS", 110, conteo_lienas, {align:"center"});
        conteo_lienas += 3;

        this.finanza.otros_pagos.forEach(otro => {

          otro.movimientos_articulos.forEach((mov, index) => {
            let raw = [];
            raw["id"] = index + 1;
            raw["descripcion"] = mov.articulos.nombre;
            raw["fecha"] = mov.created_at;
            raw["cantidad"] = mov.cantidad;
            raw["precio"] = this.convertirMoneda(parseFloat(mov.precio_unitario));
            raw["descuento"] = this.convertirMoneda(parseFloat(mov.descuento));
            raw["total"] = this.convertirMoneda(parseFloat(mov.importe));

            rows3.push(raw);
          });

          (doc as any).autoTable(columns2, rows3, {
            didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
              cell.styles.fillColor = "#ffffff";
            },
            startY: conteo_lienas,
            styles: {
              fontSize: 7, font: "helvetica",
              halign: "center",
              fillColor: "#FFFFFF",
              textColor: "#000000",
              lineColor: "#000000",
              lineWidth: 0.3,
              cellPadding: 0.4
            },
            headStyles: {
              lineColor: "#000000",
              fillColor: "#e2e2e2",
              lineWidth: 0.3
            },
            tableWidth: 'auto',
            margin: { right: 10, left: 10 },
          });
          conteo_lienas += otro.movimientos_articulos.length * 5;
        });
      }

      if (this.finanza.cupones.length > 0) {
        conteo_lienas += 10;
        doc.text("CUPON",110, conteo_lienas,  {align:"center"});
        conteo_lienas += 3;
        rows3 = [];
        this.finanza.cupones.forEach((mov, index) => {
          let raw = [];
          raw["id"] = index + 1;
          raw["descripcion"] = mov.articulos.nombre;
          raw["inicio"] = mov.inicio_vigencia;
          raw["fin"] = mov.fin_vigencia;
          raw["total"] = this.convertirMoneda(parseFloat(mov.importe));

          rows3.push(raw);
        });

        (doc as any).autoTable(columns3, rows3, {
          didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
            cell.styles.fillColor = "#ffffff";
          },
          startY: conteo_lienas,
          styles: {
            fontSize: 7, font: "helvetica",
            halign: "center",
            fillColor: "#FFFFFF",
            textColor: "#000000",
            lineColor: "#000000",
            lineWidth: 0.3,
            cellPadding: 0.4
          },
          headStyles: {
            lineColor: "#000000",
            fillColor: "#e2e2e2",
            lineWidth: 0.3
          },
          tableWidth: 'auto',
          margin: { right: 10, left: 10 },
        });
      }

      doc.setFontSize(7);
      doc.text( fecha.toUpperCase(),200, 265, {align:"right"});

      this.cargando = false;

      // doc.autoPrint();
      const string = (doc as any).output("datauristring", "finanza.pdf");

      $("#contenido").html(
        "<iframe border='0' style='border:0px' width='100%' height='100%' src='" +
        string +
        "'></iframe>");

    }, 10);
  }

  imprimirIncidencia() {
    this.cargando = true;
    moment.locale("es");
    let fecha = moment(new Date()).format("dddd [,] D [de] MMMM [del] YYYY");
    setTimeout(() => {
      let doc = new jsPDF("portrait", "mm", "letter");


      doc.setFont("helvetica");

      doc.setLineWidth(0.1);
      doc.setDrawColor(1, 1, 1);
      doc.setFillColor(255, 255, 255);

      let contador = 0;

      let alumno = this.kardex[this.alumnos.id];
      let conteo_lienas = 4;

      let logo = this.logo_sucursal != "" ? this.logo_sucursal : this.logo_empresa;
      if (logo != "")
        doc.addImage(logo, "PNG", 10, 5, 16, 16, "", "FAST");
      //Nombre empresa
      doc.setFontSize(10);
      doc.setFont("helvetica", "", "bold");
      doc.setFont("helvetica");
      doc.text(this.configuracion.empresa.nombre,110, 12,  {align:"center"});
      doc.text(this.configuracion.empresa.subnombre,110, 17,  {align:"center"});

      doc.setFontSize(8);
      doc.setFont("helvetica", "", "normal");
      doc.text("Campus: " + this.configuracion.sucursal.nombre,110, 20,  {align:"center"});

      conteo_lienas += 20;
      doc.setFontSize(8);
      doc.setFont("helvetica", "", "bold");

      doc.text("HISTORIAL DE INCIDENCIAS",110, conteo_lienas,  {align:"center"});
      conteo_lienas += 4;

      doc.setFontSize(6);
      doc.text("CARRERA: ",10, conteo_lienas,  {align:"left"});
      doc.text("CLAVE: ",145, conteo_lienas,  {align:"left"});

      doc.line(25, conteo_lienas + 1, 135, conteo_lienas + 1);
      doc.line(155, conteo_lienas + 1, 206, conteo_lienas + 1);

      doc.text("NOMBRE: ",10, conteo_lienas + 4,  {align:"left"});
      doc.text("TURNO: ",145, conteo_lienas + 4,  {align:"left"});

      doc.line(25, conteo_lienas + 5, 135, conteo_lienas + 5);
      doc.line(155, conteo_lienas + 5, 206, conteo_lienas + 5);

      doc.text("MATRICULA: ", 10, conteo_lienas + 8, {align:"left"});
      doc.text("GRUPO: ",145, conteo_lienas + 8,  {align:"left"});

      doc.line(25, conteo_lienas + 9, 135, conteo_lienas + 9);
      doc.line(155, conteo_lienas + 9, 206, conteo_lienas + 9);

      ///////////////////////////////////////
      doc.setFont("helvetica", "", "normal");

      doc.text(this.alumnos.carreras.nombre + " - " + this.alumnos.carrera_plan.nombre,30, conteo_lienas,  {align:"left"});
      doc.text(this.alumnos.carreras.sigla,160, conteo_lienas,  {align:"left"});

      doc.text(this.alumnos.alumnos_metadatos.nombre + " " + this.alumnos.alumnos_metadatos.apellido_paterno + " " + this.alumnos.alumnos_metadatos.apellido_materno,30, conteo_lienas + 4,  {align:"left"});
      doc.text( this.alumnos.grupos.turnos.nombre,160, conteo_lienas + 4, {align:"left"});

      doc.text(this.alumnos.matricula ? this.alumnos.matricula : '',30, conteo_lienas + 8,  {align:"left"});
      doc.text(this.alumnos.grupos.clave + " " + this.alumnos.grupos.nivel + " " + this.alumnos.grupos.identificador,160, conteo_lienas + 8,  {align:"left"});

      conteo_lienas += 15;

      let columns1 = [];

      let rows1 = [];

      columns1 = [
        { title: 'N°', dataKey: 'id' },
        { title: 'DESCRIPCION', dataKey: 'descripcion' },
        { title: 'FECHA', dataKey: 'fecha' }
      ];

      this.lista_incidencias.forEach((incidencia, index) => {
        let row = [];
        row["id"] = index + 1;
        row["descripcion"] = incidencia.descripcion;
        row["fecha"] = incidencia.created_at;

        rows1.push(row);
      });

      (doc as any).autoTable(columns1, rows1, {
        startY: conteo_lienas,
        styles: {
          fontSize: 7, font: "helvetica",
          halign: "center",
          textColor: "#000000",
          lineColor: "#000000",
          lineWidth: 0.3
        },
        headStyles: {
          lineColor: "#000000",
          lineWidth: 0.3
        },
        bodyStyles: {
          cellPadding: 0.4
        },
        theme: "grid",
        tableWidth: 'auto',
        margin: { right: 10, left: 10 },
      });

      doc.setFontSize(7);
      doc.text(fecha.toUpperCase(),200, 265,  {align:"right"});

      this.cargando = false;

      // doc.autoPrint();
      const string = (doc as any).output("datauristring", "incidencias.pdf");

      $("#contenido").html(
        "<iframe border='0' style='border:0px' width='100%' height='100%' src='" +
        string +
        "'></iframe>");

    }, 10);
  }

  asignarLogos(logos) {
    if (logos) {
      this.logo_sucursal = logos.sucursal;
      this.logo_empresa = logos.empresa;
      this.logo_carrera = logos.carrera;
    }
  }

  convertirMoneda(importe) {
    return (new CurrencyPipe('en')).transform(importe, this.configuracion.sucursal.moneda, true);
  }
}
